/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library ikmports
import { Component } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import ReactSelect from "react-select";

// project imports
import { getSellerUrl, getSellerHeaders, getBuyerHeaders, getBuyerUrl } from 'shared/http';
import { buyernotelist, buyernoteadd, secret_key, locationlist} from 'shared/settings/apiconfig';
import toast from 'shared/toast';
import { ArrayValueReorder } from 'shared/modifiers';

// style imports
import './Notes.scss';

/**
 * this page is used to view or add notes for sale or item
 * 
 * @param props
 * 
 * @returns html code to render note modal box
 * 
**/

export default class Notes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                // title: { value: '', error: '', valid: false, validators: [Validators.maxLength(60)] },
                isprivate: { value: false, error: '', valid: true },
                description: { value: '', error: '', valid: false },
                // locationid: { value: '', valid: false, error: '' },
            },
            valid: false,
            notes: [],
            modal: false,
            title: '',
            loading: false,
            buyerToken:'',  
            selectedLocationId: null,
            locationsValue:[] ,
            selectedOptions:[]      
        }
        this.locations = [];
    }

    componentDidMount() {
        // this.getData();
        this.getSecretKey();
        this.getLocationList();
    }
    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = ArrayValueReorder(response[0].data.data, 'title');
               
                const resultArray = this.locations.map(elm => ({ value: elm.id, label: elm.title}));

                    this.setState({
                        locationsValue:resultArray,
                        // form: {
                        //     ...this.state.form,
                        //     locationid: {
                        //         ...this.state.form.locationid,
                        //     },
                        // }
                    })
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                    formLoading: false,
                    saleStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }
    /* get data for sale or item */
    getData = () => {
        this.setState({
            ...this.state,
            title: this.props.data['title'],
            modal: this.props.modal
        }, () => {
            this.getNoteList();
        });
    }

    /* get list of notes for sale*/
    getNoteList = (message = null) => {
        const noteApi = {
            buyer: buyernotelist,
        };
        let filter = [
            {
                "field": "buyerid",
                "value": this.props.id,
                "op": "=",
                "join": "AND"
            },
            {
                "field": "locationid",
                "value": [this.props.data.user.locationid],
                "op": "IN",
                "join": "AND"
            },
        ];
        var data = {
            "filter": filter,
        };

        axios.post(getBuyerUrl(`${noteApi[this.props['name']]}`),JSON.stringify(data), { ...getBuyerHeaders(this.state.buyerToken) })
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        ...this.state,
                        notes: response.data.data.reverse(),
                        modal: this.props.modal,
                        loading: false
                    }, () => {
                        if (message) {
                            toast.success(message);
                        }
                    });
                }
            })
            .catch(error => {
                toast.error(error.response.data['message']);
            });
    }

    /*called when input changed */
    inputChange = (event) => {
        let inputError = '';
        let eventValue = event.target.value;     
        if (event.target.name === 'isprivate') {
            eventValue = !this.state.form.isprivate.value;
        }

        if (Object.keys(this.state.form[event.target.name]).includes('validators')) {
            for (let validator of this.state.form[event.target.name].validators) {
                inputError = validator(eventValue);
                if (inputError) break;
            }
        }

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [event.target.name]: {
                    ...this.state.form[event.target.name],
                    value: eventValue,
                    error: inputError,
                    valid: !Boolean(inputError)

                }
            }
        }, () => {
            if (inputError)
                this.setState({
                    ...this.state,
                    valid: false
                });
            else {
                let valid = true;
                for (let control of Object.keys(this.state.form)) {
                    if (!this.state.form[control].valid) {
                        valid = false;
                        break;
                    }
                }
                this.setState({
                    ...this.state,
                    valid: valid
                });
            }
        });

    }
    handleMultiSelect = (event) => {
        const location_id = event.map(x => x.value);
        this.setState({ selectedOptions: event });
        if(location_id.length){
            this.setState({
                selectedLocationId: location_id
            })
        }
        else{
            this.setState({
                selectedLocationId: null
            })
        }
      };
    /* reset form */
    formReset = () => {
        this.setState({
            ...this.state,
            form: {
                // title: { value: '', error: '', valid: false, validators: [Validators.maxLength(60)] },
                isprivate: { value: false, error: '', valid: true },
                description: { value: '', error: '', valid: false },
                // locationid: { value: '', error: '', valid: false }
            },
            selectedLocationId: ''
        });
    }
    getSecretKey(){
        axios.get(getSellerUrl(`${secret_key}`),getSellerHeaders()).then(
            response => {
                if (response.data.status.toLowerCase() === 'success') {
                    this.setState({
                        buyerToken: response.data.accessToken
                    }, () => {
                        this.getData()
                        // this.getbidders(response.data.accessToken)
                    })
                }
            }).catch(
                error => {
                    this.setState({
                        secretKey:""  
                    })
                }
            );
    }
    /* called when submitting form */
    submitNote = () => {
        let data = {};
        this.setState({ loading: true });
        Object.entries(this.state.form).forEach(([key, value]) =>{
            if( key !== 'isprivate'){
                data[key] = value['value']
            }        
        });
            data['buyerid'] = this.props.id;
            // if(this.state.selectedLocationId){
            //     data['locationid']=this.state.selectedLocationId
            // }
            // else{
            //     data['locationid'] = null
            // }
        // toast.success('Successful');
        const noteApi = {
            buyer: buyernoteadd
        };
        const locationArray=[];
        if(this.state.selectedLocationId){
            for(var key in this.state.selectedLocationId) {
                locationArray.push({locationid: this.state.selectedLocationId[key],buyerid:this.props.id,description:this.state.form.description.value});
            }
        }
        else{
            locationArray.push({locationid: null,buyerid:this.props.id,description:this.state.form.description.value});
        }

        let note = this.state.notes;
        let noteDict = {  isprivate: data['isprivate'], description: data['description'], addedby: this.props.data['title'], createddate: moment() };
        note.push( noteDict);
        this.setState ({ loading: false, notes: note });

        axios.post(getBuyerUrl(noteApi[this.props['name']]), JSON.stringify({ data: locationArray }), getBuyerHeaders(this.state.buyerToken))
            .then(response => {
                if (response.status === 200) {
                    this.getNoteList(response.data['status']);
                    this.formReset();
                    this.setState({ selectedOptions: [] });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    // notesStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
                // this.setState({ loading: false });
                // toast.error(error.response.data['message']);
                // this.props.hideNotes();
            })

    }

    render() {
        const { selectedOptions } = this.state;
        return (
            <Modal size="lg" className="notes" show={this.state.modal} onHide={() => this.setState({ ...this.state})} id="notes-modal">
                <Modal.Header style={{ border: "none" }}>
                    <div>
                        <h4>{this.props.name.charAt(0).toUpperCase() + this.props.name.slice(1)} Note</h4>
                        <h6>{this.state.title}</h6>
                    </div>
                    <Button type="button" onClick={() => this.props.hideNotes()} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                </Modal.Header>
                <Modal.Body style={{ padding: "0 1rem 1rem" }}>
                    { this.state.loading ?
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> : 
                        <div>
                            <div className="notesForm">
                                <Form style={{ marginBottom: "1%" }}>
                                    {/* <div style={{color: '#878787'}}>{60-this.state.form.title.value.length}/60</div> */}
                                    <div style={{ marginBottom: "1%" }}>
                                        {/* <Form.Control name="title" style={{ width: "50%" }} maxLength={60} placeholder="Add a note title here" onChange={(event) => this.inputChange(event)} value={this.state.form.title.value} /> */}
                                        {/* <Form.Check type="checkbox" name="isprivate" label="Private(Only for my locations)" style={{ float: "right" }} onChange={(event) => this.inputChange(event)} checked={this.state.form.isprivate.value} /> */}
                                        {/* <Form.Control as="select" id="locationid" name="locationid" value={this.state.form.locationid.value}  placeholder=" " required onChange={(event) => this.inputChange(event)}>
                                            <option value="">All</option>
                                                {this.locations.map((loc, index) =>
                                                    <option key={index} value={loc.id}>{loc.title}</option>
                                                )}
                                        </Form.Control> */}
                                        <ReactSelect name="locationid"
                                            isMulti
                                            defaultValue={selectedOptions}
                                            value={selectedOptions}
                                            onChange={this.handleMultiSelect}
                                            options={this.state.locationsValue}
                                            placeholder="All"
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                        />
                                    </div>
                                    <div style={{paddingTop: "2%    "}}>
                                    <div style={{color: '#878787'}}>{500-this.state.form.description.value.length}/500</div>
                                        <Form.Control as="textarea" maxLength={500} name="description" onChange={(event) => this.inputChange(event)} placeholder="Type in the body of your note here..." value={this.state.form.description.value} />
                                    </div>
                                </Form>
                                <Button varaiant="secondary" className="save-button" disabled={this.state.loading || !this.state.form.description.value} onClick={() => this.submitNote(this.state.buyerToken)}>Save</Button>

                            </div>
                            <div className={this.state.notes.length ? "notelist" : ''} >
                                {this.state.notes.map(note =>
                                    <div className="noteData">
                                        <div>
                                            <h6 style={{ width: "50%" }}><b>{note.title}</b> {note.isprivate ? <i className="fa fa-lock" style={{ color: "#A12142" }}></i> : ''}</h6>
                                            <div style={{ textAlign: "end", }}>
                                                {/* <div>{note.addedby},</div> */}
                                                <div>{ moment.utc(note.modifieddate).local().format('MM/DD/YYYY hh:mm A') } {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</div>
                                            </div>
                                        </div>
                                        <div className="notes-body" style={{ width : '80%',wordBreak:'break-word'}}>{note.description}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }    
                </Modal.Body>
            </Modal>
        );
    }
}

